'use strict';

var legalVVS = function () {
  var _getPriceLegal = function _getPriceLegal(dealersVehicle) {
    var area = dealersVehicle.dealer.territory.toLowerCase();
    var pvp = utilsVVS.formatPrice(dealersVehicle.prices.precioMostrar);
    var fuelType = dealersVehicle.vehicle.vcombustible.startsWith('El') ? 'electric' : 'combustion';

    var initialText = {
      españa: dealersVehicle.vehicle.nseccionCB === 2 ? 'PFF recomendado en Península y Baleares' : 'PVP recomendado en Península y Baleares',
      baleares: dealersVehicle.vehicle.nseccionCB === 2 ? 'PFF recomendado en Península y Baleares' : 'PVP recomendado en Península y Baleares',
      canarias: dealersVehicle.vehicle.nseccionCB === 2 ? 'Precio sin impuestos recomendado en Canarias' : 'PVP recomendado en Canarias'
    };

    var secondText = {
      españa: {
        combustion: dealersVehicle.vehicle.nseccionCB === 2 ? 'no incluye Transporte, Nissan Assistance ni impuestos.' : 'incluye PFF, transporte, Nissan Assistance, IVA e IEDMT que, para el mercado español puede no ser aplicable a su Comunidad Autónoma.',
        electric: dealersVehicle.vehicle.nseccionCB === 2 ? 'no incluye Transporte, Nissan Assistance ni impuestos.' : 'incluye PFF, transporte, Nissan Assistance e IVA.'
      },
      baleares: {
        combustion: dealersVehicle.vehicle.nseccionCB === 2 ? 'no incluye Transporte, Nissan Assistance ni impuestos.' : 'incluye PFF, descuento comercial, transporte, Nissan Assistance, IVA e IEDMT que, para el mercado español puede no ser aplicable a su Comunidad Autónoma.',
        electric: dealersVehicle.vehicle.nseccionCB === 2 ? 'no incluye Transporte, Nissan Assistance ni impuestos.' : 'incluye PFF, transporte, Nissan Assistance e IVA.'
      },
      canarias: {
        combustion: dealersVehicle.vehicle.nseccionCB === 2 ? 'que incluye Transporte y Nissan Assistance.' : 'incluye Precio exposición, IGIC y el Impuesto especial sobre determinados medios de transporte según tarifa vigente aplicable en base al nivel de emisión CO<sub>2</sub>.',
        electric: dealersVehicle.vehicle.nseccionCB === 2 ? 'que incluye Transporte y Nissan Assistance.' : 'incluye PFF, transporte, Nissan Assistance e IGIC.'
      }
    };

    var navaraText = dealersVehicle.vehicle.vmodelo.toLowerCase().includes('navara') ? '' : '';

    var priceRegistration = utilsVVS.formatPrice(dealersVehicle.prices.gastoMatriculacionEnvio);

    var registration = 'Incluye ' + priceRegistration + '\u20AC de gastos de matriculaci\xF3n y entrega. La entrega del veh\xEDculo en el domicilio puede estar sujeta a restricciones debido a las condiciones de la v\xEDa en la cual deba realizarse la entrega.';

    var moreInfo = 'Para cualquier duda puedes consultar en tu concesionario más cercano.';

    var images = 'Las imágenes mostradas pueden no coincidir totalmente con las especificaciones del vehículo.';

    var offer = dealersVehicle.prices.oferta.vnotaLegal;

    return {
      price: initialText[area] + ' (' + pvp + '\u20AC), ' + secondText[area][fuelType] + ' ' + navaraText,
      registration: registration,
      moreInfo: moreInfo,
      images: images,
      offer: offer
    };
  };
  return {
    getPriceLegal: _getPriceLegal
  };
}();